import canUseTouchScreen from '../canUseTouchscreen';

export default () => !canUseTouchScreen();
